import axios from 'axios';
import api from './DashboardReq';

export default axios.create({
    baseURL: `${api.defaults.baseURL}notes/`
});